/**
 * Google Review & Maps Constants for Bappa Taxi Services
 */

export const GOOGLE_REVIEW_URL = 'https://g.page/r/CTtJ0We1Xe6bEBE/review';

export const GOOGLE_MAPS_LOCATION_URL = 
  'https://www.google.com/maps/place/Bappa+Travels+taxi+services/@20.5780424,72.1398393,5z/data=!4m6!3m5!1s0x3bd90fe3ce991af5:0x9bee5db567d1493b!8m2!3d21.0248523!4d75.5620033!16s%2Fg%2F11stwn4bzk?entry=ttu';
